module.exports = __webpack_public_path__ + "img/bg-yellow-letters.085fcadc.png";